import React, { FC } from "react"
import { useSelector } from "react-redux"

import { getFeatures, getProduct, getProductFilters } from "@/onboarding/features/product/selectors"
import routes from "@/routes"
import ButtonLink from "@/components/ButtonLink"

const ConfirmContractPeriodDetailsButton: FC = () => {
  const {
    season: { id: seasonId },
  } = useSelector(getProduct)
  const { contractPeriodId } = useSelector(getProductFilters)
  const features = useSelector(getFeatures)

  if (!features.general.product.confirmContractPeriodDetails) {
    return null
  }

  return (
    <div>
      <ButtonLink
        label="Confirm Original Tour Details"
        modal
        button={{ variant: "success" }}
        href={routes.new_onboarding_bidding_confirm_contract_period_detail_path({
          season_id: seasonId,
          contract_period_id: contractPeriodId,
        })}
      />
    </div>
  )
}

export default ConfirmContractPeriodDetailsButton
